$(function() {

  var dirRtlFlag = false;
  if ($("#bottom-slider").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}
	$( "#datepicker" ).datepicker();
	var $status = $('.current-page');
	var $slickElement = $('#bottom-slider');

	$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
		//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
		var i = (currentSlide ? currentSlide : 0) + 1;
		$status.text(i + ' / ' + slick.slideCount);
	});

  // $('.datepicker').datepicker();
  
  $('#bottom-slider').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    fade: true,
    rtl: dirRtlFlag,
		arrows: true,
		appendArrows: $('.page-count'),
    autoplay: false,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    pauseOnHover: false
  });

  $('#second-slider').slick({
    dots: false,
    infinite: true,
    speed: 1000,
    rtl: dirRtlFlag,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false
  });


  // $('#homepage-slider').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 1000,
  //   rtl: dirRtlFlag,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 4000,
  //   arrows: false
  // });

});
